<template>
    <div class="nodeOptions">
        <ul>
            <li
            v-for="({ key, name, description, enable } , idx ) in optionList" 
            @click="setOption(key,enable)"
            :disabled="!optionList[idx].enable"
            >
                <span :style="{ backgroundImage: getImageUrl(enable,name)}"></span><button>{{name}}</button>
                <div class="description">{{description}}</div>
            </li>
        </ul>
        <button v-show="treeMode=='templeteEdit'" @click="saveTemplete">템플릿 저장</button>
    </div>
</template>
<script>
    import CommNew from "@processEditor/CommNew";

    export default{
        mixins: [CommNew],
        props : {
            selectedNodes : [] , 
            diagram : Object,
            tagTempleteData : Object,
            treeMode : String,
            selectedIssue : [],
			optionColors : [], 
            optionList : [],  

        },
        data (){
            return {

            }
        },
        watch : {
            selectedNodes : {
                handler(data){
                    this.enableSetValid()
                }
            }
        },
        mounted (){
            this.$emit('mount', this.optionList);
        },
        computed : {

        },
        methods : {
            enableSetValid(){
                for( let opt of this.optionList ) opt.enable = true;
                if( this.selectedNodes.length > 0 ){
                    for( let node of this.selectedNodes ){
                        if( node.parentData == undefined ){
                            if( this.selectedIssue.filter(o=>o.parent==node.key).length > 0 ) this.enableSet(["P","H"]);
                            else{
                                if( node["isWriter"] || node["isProcess"] || node["isKeyword"] ) this.enableSet(["P","H"]);
                                else this.enableSet(["P","H","L"]);
                            }
                        }else{
                            if( node.parentData && node.parentData["T"] ) this.enableSet(["R","C","D"]);
                            else this.enableSet(["R","C","D","M","V","L","H","T"]);
                        }
                        if( node["R"] ) this.enableSet(["R","C","D","M","V","L","H","T"]);
                        if( node["C"] ) this.enableSet(["R","C","D","M","V","L","H","T"]);
                        if( node["D"] ) this.enableSet(["R","C","D","M","V","L","H"]);
                        if( node["M"] ) this.enableSet(["R","C","M","V","L"]);
                        if( node["V"] ) this.enableSet(["R","C","M","V","L","H"]);
                        if( node["L"] ) this.enableSet(["R","C","M","V","L","H"]);
                        if( node["H"] ) this.enableSet(["R","C","L","V","H"]);
                        if( node["T"] ) this.enableSet(["T"]);
                    }
                }
            },
            enableSet(enableList){
                for( let opt of this.optionList ){
                    if( !enableList.includes(opt.key) )  opt.enable = false;
                }
            },

            getParentDisplay(parentKey){
                return this.selectedIssue.filter(o=>o.key == parentKey)[0]?.display;
            },

            setOption(key,enable){
                if( !enable ) return;
                if( !this.selectedNodes.length ) return;
                this.selectedIssue.forEach(node => {
                    if( this.selectedNodes.find(selectNode=>selectNode.key == node.key) ){
                        if( node[key] ){
                            delete node[key];
                            if( key == "R" || key == "C" ){
                                delete node["display"];
                            }
                        }else{
                            node[key] = true;
                            if( key == "R" || key == "C" ){
                                node["display"] = false;
                            }
                        }

                        if( key == "R" && node["R"] == true && node["C"] == true ) delete node["C"];
                        if( key == "C" && node["C"] == true && node["R"] == true ) delete node["R"];
                        if( key == "V" && node["V"] == true && node["L"] == true ) delete node["L"];
                        if( key == "L" && node["L"] == true && node["V"] == true ) delete node["V"];
                        

                        const parentDisplay = this.getParentDisplay(node.parent);
                        // console.log( node.parent, parentDisplay )
                        if( parentDisplay !== undefined ){
                            node["display"] = parentDisplay;
                        }
                    }
                });

                if( this.treeMode != 'templeteEdit'){
                    let { protocols } = this.PROCESS_INFO; 
                    const slctProtocol = protocols.filter( protocol => protocol.id == this.$route.query.protocolId )[0] ; 
                    if( typeof slctProtocol.json === "string" ) slctProtocol.json = JSON.parse(slctProtocol.json);		                    
                    slctProtocol.json.issues = this.selectedIssue;
                }

                this.diagram.clearSelection();
                this.$emit("change");
                // console.log(this.selectedIssue);
            },
            async saveTemplete(){
                // console.log("templete",this.tagTempleteData)
                let nodeOptionCount=0;
                for( let node of this.selectedIssue ){
                    nodeOptionCount=0;
                    for( let opt of this.optionList ){
                        // if( opt.key == "H" ) continue;
                        if( node[opt.key] ) nodeOptionCount++;
                    }
                    if( !nodeOptionCount ) break;
                }
                if( !nodeOptionCount ){
                    window.alert("노드 속성이 적용되지 않은 노드가 존재하여, 저장이 불가합니다.");
                    return;
                }

                const json = {issues:this.selectedIssue}
                const content = JSON.stringify(json);
                // const content = json;
                const data = {
                    idTag : this.tagTempleteData.tagId,
                    content
                };
                // await this.$wApi.tag.template.make({idTag:40},40)
                // console.log( "data", data );
                const rep = await this.$wApi.tag.template.update(data,this.tagTempleteData.tagId);
                if( rep.code ){
                    window.alert(rep.message);
                }else{
                    window.wToast(this.tagTempleteData.name+"의 템플릿 저장을 완료하였습니다." , {
                        variant: "wtoast-bg",
                    }) ; 
                }
                // console.log("response", rep);
            },
            getImageUrl(enable,name){
                name += enable ? "_on.png" : "_off.png";
                let url = `url(${require(`@/assets/protocol/${name}`)})`;
                return url;
            }
        }
    }
</script>
<style lang="scss">
    .nodeOptions{
        position:fixed;
        right:20px;
        top:180px;
        border:1px solid #ddd;
        padding:20px;
        border-radius:15px;
        background:#fff;
        z-index:10;
        >button{
            background:#4879BB;
            color:#fff;
            padding:10px 15px;
            text-align:center;
            margin-top:20px;
            border-radius:15px;
            width:100%;
        }
        ul{
            li{
                position:relative;
                display:flex;
                align-items:center;
                padding:5px;
                &:hover{
                    .description{
                        visibility: visible;
                    }
                }
                &[disabled]{
                    >button{
                        color:#999;
                        text-decoration:none;
                        cursor:none;
                    }
                }
                span{
                    display:block;
                    background-size: cover;
                    height: 27px;
                    width: 27px;
                    margin-right: 10px;
                }
                >button{
                    border:0;
                    text-decoration: underline;
                    text-underline-position: under;
                    cursor:pointer;
                }
                .description{
                    visibility: hidden;
                    position:absolute;
                    right:100%;
                    top:-5px;
                    border:1px solid #ddd;
                    padding:10px 15px;
                    border-radius:15px;
                    z-index:10;
                    background:#fff;
                    white-space: nowrap;
                    
                }
            }
            li+li{
                margin-top:5px;
            }
        }
    }
</style>